import React from 'react'
import { ParkedSaleStore } from './ParkedSaleStore'
import { Button } from 'antd-v4'
import { LocalStorage } from '../../../../utilities/LocalStorage'

interface State {
  timeElapsedSeconds: number
  shouldPlayNotification: boolean
}

interface Props {
  parkedSaleStore: ParkedSaleStore
}

export class RefreshMessage extends React.Component<Props, State> {
  refreshTime: number = 1000 * 30 // 30 seconds

  state = {
    timeElapsedSeconds: 0,
    shouldPlayNotification: LocalStorage.getShouldPlayParkedSaleAudioNotification(),
  }

  updateTime = () => {
    const { searchPaymentQueues, isRefreshed, setRefreshed } = this.props.parkedSaleStore
    const { timeElapsedSeconds, shouldPlayNotification } = this.state

    this.setState({ timeElapsedSeconds: timeElapsedSeconds + 1 })

    // Reset the timer when new paymentQueues is fetched
    if (isRefreshed) {
      setRefreshed(false)
      this.setState({ timeElapsedSeconds: 0 })
    }

    // Reload filtered paymentQueues after 30 seconds
    if (this.state.timeElapsedSeconds === this.refreshTime / 1000) {
      searchPaymentQueues(shouldPlayNotification)
    }
  }

  interval: NodeJS.Timer = setInterval(this.updateTime, 1000)

  componentWillUnmount = () => {
    clearInterval(this.interval)
  }

  handlePlayNotificationUpdate = () => {
    const { shouldPlayNotification } = this.state
    LocalStorage.setShouldPlayParkedSaleAudioNotification(!shouldPlayNotification)
    this.setState({ shouldPlayNotification: !shouldPlayNotification })
  }

  render() {
    const { timeElapsedSeconds, shouldPlayNotification } = this.state
    const remainTime = this.refreshTime / 1000 - timeElapsedSeconds

    return (
      <div style={{ display: 'flex', flex: 1, alignItems: 'center' }}>
        <Button
          onClick={this.handlePlayNotificationUpdate}
          className='d-flex align-items-center mr-2'
        >
          <span>New Orders</span>
          <span
            style={{ fontSize: '22px' }}
            className={`fa fa-volume-${shouldPlayNotification ? 'up' : 'off'} ml-2`}
          />
        </Button>
        <span>
          Refresh in {remainTime} {remainTime > 1 ? 'seconds' : 'second'}
        </span>
      </div>
    )
  }
}
